import React, { forwardRef } from 'react';
import { Typography as MuiTypography, TypographyProps as MuiTypographyProps, TypographyTypeMap } from '@material-ui/core';
import styled from 'styled-components';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';


type FontWeight = 'light' | 'regular' | 'medium' | 'semiBold' | 'bold';
type MuiFontWeight = 'fontWeightLight' | 'fontWeightRegular' | 'fontWeightMedium' | 'fontWeightSemiBold' | 'fontWeightBold';

export const fontWeightMap: Record<FontWeight, MuiFontWeight> = {
    light: 'fontWeightLight', // 300
    regular: 'fontWeightRegular', // 400
    medium: 'fontWeightMedium', // 500
    semiBold: 'fontWeightSemiBold', // 600
    bold: 'fontWeightBold', // 700
};

export interface TypographyProps extends MuiTypographyProps {
    fontWeight?: FontWeight;
    uppercase?: boolean;
    colorVariant?: 'success' | 'error' | 'primary' | 'warning';
}

export const Typography: OverridableComponent<TypographyTypeMap<TypographyProps>> = styled(
    forwardRef<HTMLSpanElement, TypographyProps>((
        { fontWeight, uppercase, colorVariant, ...props },
        ref,
    ) => <MuiTypography {...props} ref={ref} />)
)`
    ${({ uppercase }) => uppercase && `text-transform: uppercase;`}
    ${({ fontWeight, theme }) => fontWeight && `
        && {
            font-weight: ${theme.typography[fontWeightMap[fontWeight]]};
        }`}
    ${({ onClick }) => onClick && `
        &:hover {
            cursor: pointer;
            text-decoration: underline;
        }
    `}

    && {
        ${({ colorVariant, theme }) => colorVariant && `color: ${theme.palette[colorVariant].main} !important;`}
    }
`;